<script lang="ts">
    import cn from 'classnames';

    import s from '../styles.module.css';
</script>

<ul class={cn(s.bulletList)}><slot /></ul>
